import sdl from '@jds/react-generated-sdl/JDSVerticalStepper';
import type { JDSVerticalStepperProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, StepperProps, type StepperRef } from '../logic';

const Component = (props: StepperProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { custom = '', ...rest } = props as any;
  return createComponent(
    json,
    rest,
    'JDSVerticalStepper',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const VerticalStepper = withLogic(Component) as React.ForwardRefExoticComponent<
  StepperProps & React.RefAttributes<StepperRef>
> & { slotName?: string };

VerticalStepper.displayName = 'VerticalStepper';
VerticalStepper.slotName = 'jds_vertical_stepper';

export { VerticalStepper, type JDSVerticalStepperProps };
